export default {
  imageCode: "/gateway/partyH5App/huilianApi/messagecs/imageCode", //获取图片验证码
  messageCode: "/gateway/huilianApi/messagecs/messageCode", //发送短信验证码
  validateMessageCode:
    "/gateway/partyH5App/manageBedrock/messagecs/validateMessageCode", // 校验验证码是否正确
};



// WEBPACK FOOTER //
// ./src/vehicleInquiry/change/api.js